import { ANEL_OFF, TITULO } from './checkoutUi';

/**
 * Só texto e cor. Os valores continuam vindo do backend, em
 * `eventoInfo.valorCentavos`, `valorMembroCentavos` e
 * `valorSocialCentavos` — nenhum preço mora aqui.
 */
export const PLANOS = [
  {
    id: 'assinatura',
    nome: 'Lily Member',
    kicker: 'Membros fixos',
    cor: '#8b3fd9',
    tint: '#f3eafc',
    beneficios: [
      'Acesso ao encontro do mês',
      'Espaço contínuo de troca e referências',
      'Mínimo de 4 edições consecutivas',
    ],
  },
  {
    id: 'encontro_avulso',
    nome: 'Lily Pass',
    kicker: 'Ingresso avulso',
    cor: '#ff2368',
    tint: '#fff0f4',
    beneficios: [
      'Acesso ao encontro do mês',
      'Troca de leituras, referências e ideias',
      'Quiz do mês, com chance de ganhar mimos',
      'Passaporte de entrada para o clube',
    ],
  },
  {
    id: 'ingresso_social',
    nome: 'Ingresso Social',
    kicker: 'Ingresso social',
    cor: '#13a06b',
    tint: '#e8f8f0',
    beneficios: [
      'Acesso à edição mensal completa',
      'Participação plena na discussão',
      'Exclusivo para mulheres cis e trans em vulnerabilidade social, mediante comprovação',
    ],
  },
];

const emReais = (centavos) => (centavos / 100).toFixed(2).replace('.', ',');

function PlanCard({ plano, selecionado, onSelect, precoCentavos, addOns }) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selecionado}
      className="flex cursor-pointer flex-col gap-2.5 rounded-2xl border-0 border-l-[5px] bg-white px-4 py-4 text-left lg:gap-2 lg:rounded-[14px] lg:border-l-0 lg:border-t-4 lg:p-4"
      style={{
        borderColor: plano.cor,
        boxShadow: selecionado
          ? `inset 0 0 0 1.5px ${plano.cor}, 0 8px 20px rgba(15,23,41,.06)`
          : ANEL_OFF,
      }}
    >
      {/* Web: pill em cima, nome e preço na mesma linha.
          Celular: nome + kicker à esquerda, preço à direita. */}
      <span
        className="hidden self-start whitespace-nowrap rounded-full px-2 py-[3px] text-[9px] font-bold uppercase tracking-[.04em] lg:inline-block"
        style={{ background: plano.tint, color: plano.cor }}
      >
        {plano.kicker}
      </span>
      <span className="flex items-center justify-between gap-2 lg:items-baseline">
        <span className="flex flex-col">
          <span className="text-base font-bold text-[#0f1729] lg:text-[13px]">
            {plano.nome}
          </span>
          <span
            className="text-[10.5px] font-bold uppercase tracking-[.03em] lg:hidden"
            style={{ color: plano.cor }}
          >
            {plano.kicker}
          </span>
        </span>
        <span className="whitespace-nowrap text-[22px] font-extrabold tabular-nums text-[#0f1729] lg:text-xl">
          R$ {emReais(precoCentavos)}
        </span>
      </span>

      {/* Os benefícios ficam sempre à vista, nos três planos. */}
      <span className="flex flex-col gap-1.5 border-t border-[#eef0f4] pt-2.5 lg:gap-1 lg:border-t-0 lg:pt-0">
        {plano.beneficios.map((b) => (
          <span
            key={b}
            className="flex gap-2 text-[13px] leading-[1.4] text-[#4b5568] lg:gap-1.5 lg:text-[11px] lg:leading-[1.35]"
          >
            <span className="font-bold" style={{ color: plano.cor }}>
              ✓
            </span>
            {b}
          </span>
        ))}
        {addOns.map((a) => (
          <span
            key={a.id ?? a.description}
            className="flex gap-2 text-[13px] leading-[1.4] text-[#4b5568] lg:gap-1.5 lg:text-[11px] lg:leading-[1.35]"
          >
            <span className="font-bold" style={{ color: plano.cor }}>
              +
            </span>
            Inclui {a.description} (R$ {emReais(a.priceInCents)})
          </span>
        ))}
      </span>
    </button>
  );
}

export default function PlanStep({
  planoSelecionado,
  setPlanoSelecionado,
  eventoInfo,
}) {
  const precos = {
    ingresso_social: eventoInfo?.valorSocialCentavos ?? 2999,
    encontro_avulso: eventoInfo?.valorCentavos ?? 8399,
    assinatura: eventoInfo?.valorMembroCentavos ?? 6499,
  };
  const addOns = eventoInfo?.addOns || [];
  const addOnsTotal = addOns.reduce((sum, a) => sum + a.priceInCents, 0);

  // Plano com valor zerado no evento não é oferecido.
  const disponiveis = PLANOS.filter((p) => {
    if (p.id === 'assinatura')
      return (eventoInfo?.valorMembroCentavos ?? 0) > 0;
    if (p.id === 'ingresso_social')
      return (eventoInfo?.valorSocialCentavos ?? 0) > 0;
    return true;
  });

  return (
    <div className="flex flex-col gap-3 lg:gap-3.5">
      <h2 className={TITULO}>Escolha seu ingresso</h2>
      <div
        className="grid grid-cols-1 gap-3 lg:grid-cols-[repeat(var(--colunas),minmax(0,1fr))] lg:gap-3"
        style={{ '--colunas': Math.min(disponiveis.length, 3) }}
      >
        {disponiveis.map((plano) => (
          <PlanCard
            key={plano.id}
            plano={plano}
            selecionado={planoSelecionado === plano.id}
            onSelect={() => setPlanoSelecionado(plano.id)}
            precoCentavos={precos[plano.id] + addOnsTotal}
            addOns={addOns}
          />
        ))}
      </div>
    </div>
  );
}
